import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, DefaultValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HappyInputBase } from '../happy-template-input/happy-input-base';

export const DROPDOWN_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HappyDropdownComponent),
    multi: true,
};

@Component({
    selector: 'happy-dropdown',
    templateUrl: './happy-dropdown.component.html',
    styleUrls: ['./happy-dropdown.component.css', '../styles.css'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [DROPDOWN_VALUE_ACCESSOR]
})
export class HappyDropdownComponent extends HappyInputBase {

    @Input() items: Array<{ key: string, value: string }>;
    @Input() config: IHappyDropdownConfig;
    @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;
    // We're keeping a copy of the underlying data since pre-selection is not maintained
    val: any;

    constructor(parentForm: FormGroupDirective) {
        super(parentForm);
    }

    ngOnInit() {
        this.form = this.parentForm.form;
    }

    writeValue(obj: any) {
        this.valueAccessor.writeValue(obj);
        this.val = obj;
    }

    registerOnChange(fn: any) {
        this.valueAccessor.registerOnChange(fn);
    }

    registerOnTouched(fn: any) {
        this.valueAccessor.registerOnTouched(fn);
    }

    setDisabledState(isDisabled: boolean) {
        this.valueAccessor.setDisabledState(isDisabled);
    }
}

export interface IHappyDropdownConfig {
    noSelectionText?: string;
    selectableEmpty?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-dropdown/happy-dropdown.component.ts